const icons = {
  default: { class: 'fal fa-file', content: '\uf15b', descr: 'File' },
  text: { class: 'fal fa-file-alt', content: '\uf15c', descr: 'Text File' },
  pdf: { class: 'fal fa-file-pdf', content: '\uf1c1', colour: '#e31d1a', descr: 'PDF' },
  word: { class: 'fal fa-file-word', content: '\uf1c2', colour: '#2a5696', descr: 'Document' },
  excel: { class: 'fal fa-file-excel', content: '\uf1c3', colour: '#1d7044', descr: 'Spreadsheet' },
  powerpoint: { class: 'fal fa-file-powerpoint', content: '\uf1c4', colour: '#d04424', descr: 'Presentation' },
  image: { class: 'fal fa-file-image', content: '\uf1c5', descr: 'Image' },
  zip: { class: 'fal fa-file-archive', content: '\uf1c6', descr: 'Archive' },
  audio: { class: 'fal fa-file-audio', content: '\uf1c7', descr: 'Audio File' },
  video: { class: 'fal fa-file-video', content: '\uf1c8', descr: 'Video' },
  code: { class: 'fal fa-file-code', content: '\uf1c9', descr: 'Source Code' }
}

const contentTypes = {
  word: ['msword', 'nd.ms-word', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'vnd.google-apps.document'],
  excel: ['msexcel', 'vnd-ms-excel', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.google-apps.spreadsheet'],
  powerpoint: ['vnd.ms-powerpoint', 'vnd.openxmlformats-officedocument.presentationml.presentation', 'vnd.google-apps.presentation']
}

const extensions = {
  audio: ['aif', 'cda', 'm4a', 'mid', 'midi', 'mp3', 'mpa', 'ogg', 'wav', 'wm', 'wpl'],
  zip: ['7z', 'arj', 'deble', 'gz', 'pkg', 'rar', 'rpm', 'tar', 'z', 'zip'],
  text: ['csv', 'log', 'xml'],
  image: ['ai', 'bmp', 'gif', 'ico', 'jpg', 'jpeg', 'png', 'ps', 'psd', 'tif', 'tiff'],
  code: ['asp', 'cer', 'cfm', 'cgi', 'css', 'htm', 'html', 'js', 'json', 'jsp', 'php', 'py', 'rss', 'xhtml', 'c', 'class', 'cpp', 'cs', 'h', 'java', 'sh', 'swift', 'vb'],
  powerpoint: ['key', 'odp', 'pps', 'ppt', 'pptx'],
  excel: ['ods', 'xlr', 'xls', 'xlsx'],
  video: ['3g2', '3gp', 'avi', 'flv', 'h264', 'm4v', 'mkv', 'mov', 'mp4', 'mpg', 'rm', 'swf', 'vob', 'wmv'],
  word: ['doc', 'docx', 'odt', 'rtf', 'tex', 'wks', 'wpd'],
  pdf: ['pdf']
}

const findKey = function (o, value, defaultKey) {
  let match = defaultKey
  Object.keys(o).forEach((key) => {
    if (o[key].indexOf(value) >= 0) {
      match = key
    }
  })
  return match
}

export default {
  get: function (type) {
    const parts = type.split('/')

    if (parts.length === 0) {
      return ''
    }

    if (parts[0] === 'application') {
      return parts.length > 1 ? parts[1] : ''
    }

    return parts[0]
  },

  iconForType: function (type) {
    type = this.get(type)
    const key = findKey(contentTypes, type, type)
    return icons[key] ? icons[key] : icons.default
  },

  iconForName: function (name) {
    return this.iconForType(this.typeForName(name))
  },

  typeForName: function (name) {
    const extension = name.split('.').pop().toLowerCase()
    const matchedType = findKey(extensions, extension, 'default')
    return matchedType
  },

  iconClassForType: function (type) {
    return this.iconForType(type).class
  },

  iconContentForType: function (type) {
    return this.iconForType(type).content
  },

  isImage: function (type) {
    return this.get(type) === 'image'
  },

  iconForNameOrType: function (name, type) {
    let icon = this.iconForType(type)
    if (icon === icons.default || icon === icons.text) {
      const nameIcon = this.iconForName(name)
      if (nameIcon !== icons.default) {
        icon = nameIcon
      }
    }
    return icon
  }
}
